import { Routes } from '@angular/router';
import { NotFoundComponent } from 'src/shared/components/notfound/notfound.component';
import { MAINTENANCE_WINDOW_PATH } from 'src/shared/constants/maintenance-window.constants';
import { LoginGuard } from 'src/shared/guards/login.guard';
import { maintenanceGuard } from 'src/shared/guards/maintenance-window.guard';
import { accountRoutes } from './account/account-routing';
import { appointmentsRoutes } from './appointments/appointments-routing';
import { calendarRoutes } from './calendar/calendar-routing';
import { consultationRoutes } from './consultations/consultations-routing';
import { dashboardRoutes } from './dashboard/dashboard-routing';
import { onboardingRoutes } from './onboarding/onboarding-routing';
import { trialConsultationRoutes } from './trial-consultation/trial-consultation.routing';
import { usaRoutes } from './usa/usa-routing';

export const pmsRoutes: Routes = [
  {
    path: 'checkaccess',
    loadComponent: () =>
      import('src/shared/components/authentication/checkstaffaccess/checkstaffaccess.component').then(
        (x) => x.CheckStaffAccessComponent
      ),
    canActivate: [maintenanceGuard, LoginGuard],
    title: 'Check Access',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('src/shared/components/authentication/login/login.component').then((x) => x.LoginComponent),
    canActivate: [maintenanceGuard],
    title: 'Login',
  },
  {
    path: 'register',
    loadComponent: () =>
      import('src/shared/components/authentication/register/register.component').then((x) => x.RegisterComponent),
    canActivate: [maintenanceGuard],
    title: 'Register',
  },
  {
    path: 'forgottenpassword',
    loadComponent: () =>
      import('src/shared/components/authentication/forgottenpassword/forgottenpassword.component').then(
        (x) => x.ForgottenPasswordComponent
      ),
    canActivate: [maintenanceGuard],
    title: 'Forgotten Password',
  },
  {
    path: 'tenants/:redirectUrl',
    loadComponent: () =>
      import('src/shared/components/authentication/tenants/tenants.component').then((x) => x.TenantsComponent),
    canActivate: [maintenanceGuard],
  },
  {
    path: 'unauthorised',
    loadComponent: () =>
      import('src/shared/components/notauthorised/notauthorised.component').then((x) => x.NotAuthorisedComponent),
    canActivate: [maintenanceGuard],
    title: 'Access denied',
  },
  { path: '', redirectTo: 'checkaccess', pathMatch: 'full' },
  {
    path: '',
    canActivateChild: [maintenanceGuard],
    children: [
      ...onboardingRoutes,
      ...dashboardRoutes,
      ...consultationRoutes,
      ...calendarRoutes,
      ...appointmentsRoutes,
      ...accountRoutes,
      ...trialConsultationRoutes,
      ...usaRoutes,
    ],
  },
  {
    path: MAINTENANCE_WINDOW_PATH,
    loadComponent: () =>
      import('src/shared/components/maintenance-window/maintenance-window-page/maintenance-window-page.component').then(
        (x) => x.MaintenanceWindowPageComponent
      ),
    title: 'Under Maintenance',
  },
  {
    path: 'notfound',
    component: NotFoundComponent,
    canActivate: [maintenanceGuard],
    title: 'Page Not Found',
  },
  { path: '**', redirectTo: 'notfound' },
];
